/*
 * -----------------------------------------------------------------------
 *  <copyright file="add-rules.data.ts" company="Triumph Research Intelligence">
 *      Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { RuleClauseEnumType, RuleClauseOperatorEnumType } from '@types/graphql-global-types';

export const ADD_RULES_FIELD_TYPES = {
    default: 'default',
    BOOL: 'BOOL',
    TEXT: 'TEXT',
    INT: 'INT',
    DATE: 'DATE',
};

export const ADD_RULES_FIELD_DATA = [
    { id: ADD_RULES_FIELD_TYPES.default, text: 'Select a Value', default: true },
    { id: ADD_RULES_FIELD_TYPES.BOOL, text: 'Boolean' },
    { id: ADD_RULES_FIELD_TYPES.TEXT, text: 'String' },
    { id: ADD_RULES_FIELD_TYPES.INT, text: 'Number' },
    { id: ADD_RULES_FIELD_TYPES.DATE, text: 'Date' },
];

export const ADD_RULES_OPERATOR_DATA = {
    [ADD_RULES_FIELD_TYPES.default]: [
        { id: RuleClauseOperatorEnumType.IS_NULL, text: 'Select a Value', default: true },
    ],
    [ADD_RULES_FIELD_TYPES.BOOL]: [
        { id: RuleClauseOperatorEnumType.IS_NULL, text: 'Select a Value', default: true },
        { id: RuleClauseOperatorEnumType.EQUALS, text: 'Equals' },
        { id: RuleClauseOperatorEnumType.NOT_EQUALS, text: 'Does Not Equal' },
        { id: RuleClauseOperatorEnumType.IS_BLANK, text: 'Is Blank' },
        { id: RuleClauseOperatorEnumType.IS_NOT_BLANK, text: 'Is Not Blank' },
    ],
    [ADD_RULES_FIELD_TYPES.TEXT]: [
        { id: RuleClauseOperatorEnumType.IS_NULL, text: 'Select a Value', default: true },
        { id: RuleClauseOperatorEnumType.EQUALS, text: 'Equals' },
        { id: RuleClauseOperatorEnumType.NOT_EQUALS, text: 'Does Not Equal' },
        { id: RuleClauseOperatorEnumType.CONTAINS, text: 'Contains' },
        { id: RuleClauseOperatorEnumType.DOES_NOT_CONTAIN, text: 'Does Not Contain' },
        { id: RuleClauseOperatorEnumType.IS_BLANK, text: 'Is Blank' },
        { id: RuleClauseOperatorEnumType.IS_NOT_BLANK, text: 'Is Not Blank' },
    ],
    [ADD_RULES_FIELD_TYPES.INT]: [
        { id: RuleClauseOperatorEnumType.IS_NULL, text: 'Select a Value', default: true },
        { id: RuleClauseOperatorEnumType.EQUALS, text: 'Equals' },
        { id: RuleClauseOperatorEnumType.NOT_EQUALS, text: 'Does Not Equal' },
        { id: RuleClauseOperatorEnumType.GREATER_THAN, text: 'Greater Than' },
        { id: RuleClauseOperatorEnumType.GREATER_THAN_EQUALS, text: 'Greater Than or Equal To' },
        { id: RuleClauseOperatorEnumType.LESS_THAN, text: 'Less Than' },
        { id: RuleClauseOperatorEnumType.LESS_THAN_EQUALS, text: 'Less Than or Equal To' },
        { id: RuleClauseOperatorEnumType.IS_BLANK, text: 'Is Blank' },
        { id: RuleClauseOperatorEnumType.IS_NOT_BLANK, text: 'Is Not Blank' },
    ],
    [ADD_RULES_FIELD_TYPES.DATE]: [
        { id: RuleClauseOperatorEnumType.IS_NULL, text: 'Select a Value', default: true },
        { id: RuleClauseOperatorEnumType.IS_BLANK, text: 'Is Blank' },
        { id: RuleClauseOperatorEnumType.IS_NOT_BLANK, text: 'Is Not Blank' },
    ],
};

export const ADD_RULES_BOOL_FIELD_DATA = [
    { id: RuleClauseOperatorEnumType.IS_NULL, text: 'Select a Value', default: true },
    { id: 'yes', text: 'Yes' },
    { id: 'no', text: 'No' },
];

export const ADD_RULES_AND_OR = [
    { id: RuleClauseEnumType.NONE, text: 'Select a Value', default: true },
    { id: RuleClauseEnumType.AND, text: 'And' },
    { id: RuleClauseEnumType.OR, text: 'Or' },
];

export const SHOW_VALUE_FIELD_REGEX = new RegExp(
    `${RuleClauseOperatorEnumType.EQUALS}|${RuleClauseOperatorEnumType.NOT_EQUALS}|${RuleClauseOperatorEnumType.GREATER_THAN}|${RuleClauseOperatorEnumType.GREATER_THAN_EQUALS}|${RuleClauseOperatorEnumType.LESS_THAN}|${RuleClauseOperatorEnumType.LESS_THAN_EQUALS}|${RuleClauseOperatorEnumType.CONTAINS}|${RuleClauseOperatorEnumType.DOES_NOT_CONTAIN}`,
);
